import React, { useState } from 'react';

import { FlatButton } from '@travel/ui';
import { Filter } from '@travel/icons/ui';

import styles from './filterContainer.module.scss';

type Props = {
  className?: string;
  /** Callback to be called when button is clicked */
  onClick?: () => void;
  /** String of button title */
  title: React.ReactNode;
  name?: string;
};

function StyledButton(props: Props) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={props.className}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
    >
      <FlatButton
        className={styles.filterButton}
        icon={<Filter size={16} color={isHovered ? 'lincolnGreen' : 'cilantro'} />}
        classType="secondary"
        onClick={props.onClick}
        data-testid={`styledButton-${props.name || 'noNameProp'}-flatButton`}
      >
        {props.title}
      </FlatButton>
    </div>
  );
}

export default StyledButton;
